import {Post} from "../server";

// 获取机器人产品列表 不传产品id为新增， 传产品id为升级
export function list(robot_id = 0) {
    return Post("/api1/robotProducts/list", {robot_id: robot_id});
}

export const robotProducts = {
    list,
};